import { useEffect } from 'react';
import { useFetchAndModifyProducts } from 'helpers/hooks/useMonetateProduct';
import { sendToMonetate } from 'helpers/utils/monetateHelper';
import { useAccount, useCart } from 'frontastic';

const GlobalMonetateHook = ({ isLoginModalOpen, pageProps }) => {
  const { loggedIn } = useAccount();
  const { studioConfig, data } = useCart();
  useFetchAndModifyProducts({
    selector: '.mt-merch-item',
    onTriggerLogin: () => {
      if (!loggedIn) {
        isLoginModalOpen(true);
      }
    },
  });

  useEffect(() => {
    const pathname = window?.location?.pathname;
    const isDealsPage = pathname?.includes('/deal') || pageProps?.data?.page === 'deals';

    if (isDealsPage && studioConfig?.monetateConstants) {
      let monetateConfig;
      try {
        monetateConfig = JSON?.parse(studioConfig?.monetateConstants?.replace(/'/g, '"'));
      } catch (error) {
        console.error('Error parsing monetateConstants:', error);
        return;
      }

      const dataMonetate = {
        page: 'deals-page',
        cart: {
          ...data,
        },
        url: window.location.href,
      };

      sendToMonetate(dataMonetate, monetateConfig);
    }
  }, [pageProps?.data, studioConfig]);

  return null;
};

export default GlobalMonetateHook;
